import { toTenantDate } from '@utils/timeZone';

export const getSegment = (x: number, y: number) => {
  return document.elementsFromPoint(x, y).find((el) => el.classList.contains('scheduler-segment'));
};

export const getSegmentFromPoint = (x: number, y: number) =>
  toTenantDate(getSegment(x, y)?.getAttribute('data-date') || '');
